import React from "react";
import { useState } from "react";
import { Button } from "react-bootstrap";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";

const CertificationShowModal = (props) => {
  const [show, setShow] = useState(props.show);

  const handleClose = () => {
    setShow(false);
    props.handelCloseShow(false);
  };
  console.log(props.certificationData);

  return (
    <Modal className="course-modal" size="xl" onHide={handleClose} show={show}>
      <Modal.Header>
        <Modal.Title className="dis-con">
          <h3 className="color-white">
            {props.certificationData && props.certificationData.name}
          </h3>
          <Button className="btn-common" onClick={handleClose}>
            <i class="fa fa-times" aria-hidden="true"></i>
          </Button>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div class="paths-content-description">
          <p></p>
          <div class="paths-content-highlight paths-aside-box show-for-large-up">
            <div class="paths-aside-scrollable">
              <div className="row">
                <div className="col-lg-5 mb-2">
                  <h4 className="color-white">Product Name:</h4>
                </div>
                <div className="col-lg-7 mb-2">
                  <h4 className="color-white">
                    {props.certificationData &&
                      props.certificationData.product_name}
                  </h4>
                </div>
              </div>

              <div className="row">
                <div className="col-lg-5 mb-2">
                  <h4 className="color-white">Certification Type : </h4>
                </div>
                <div className="col-lg-7 mb-2">
                  <h4 className="color-white">
                    {props.certificationData &&
                      props.certificationData.certification_type}
                  </h4>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-5 mb-2">
                  <h4 className="color-white">Certification Role : </h4>
                </div>
                <div className="col-lg-7 mb-2">
                  <h4 className="color-white">
                    {props.certificationData &&
                      props.certificationData.certification_role}
                  </h4>
                </div>
              </div>

              <div className="row">
                <div className="col-lg-5 mb-2">
                  <h4 className="color-white">Exam:</h4>
                </div>
                <div className="col-lg-7 mb-2">
                  <h4 className="color-white">
                    {props.certificationData && props.certificationData.exam}
                  </h4>
                </div>
              </div>

              <div className="row">
                <div className="col-lg-5 mb-2">
                  <h4 className="color-white">Level:</h4>
                </div>
                <div className="col-lg-7 mb-2">
                  <h4 className="color-white">
                    {props.certificationData && props.certificationData.level}
                  </h4>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-5 mb-2">
                  <h4 className="color-white">Duration:</h4>
                </div>
                <div className="col-lg-7 mb-2">
                  <h4 className="color-white">
                    {" "}
                    {props.certificationData &&
                      props.certificationData.duration}
                  </h4>
                </div>
              </div>

              <div className="row">
                <div className="col-lg-5 mb-2">
                  <h4 className="color-white">Cost in $: </h4>
                </div>
                <div className="col-lg-7 mb-2">
                  <h4 className="color-white">
                    {" "}
                    {props.certificationData &&
                      props.certificationData.cost_doller}
                  </h4>
                </div>
              </div>

              <div className="row">
                <div className="col-lg-5 mb-2">
                  <h4 className="color-white">Cost in RS: </h4>
                </div>
                <div className="col-lg-7 mb-2">
                  <h4 className="color-white">
                    {" "}
                    {props.certificationData &&
                      props.certificationData.cost_inr}
                  </h4>
                </div>
              </div>

              <div className="row">
                <div className="col-lg-5 mb-2">
                  <h4 className="color-white">Recommended Experience:</h4>
                </div>
                <div className="col-lg-7 mb-2">
                  <h4 className="color-white">
                    {props.certificationData &&
                      props.certificationData.recommended_experience}
                  </h4>
                </div>
              </div>

              <div className="row">
                <div className="col-lg-5 mb-2">
                  <h4 className="color-white">Exam Link:</h4>
                </div>
                <div className="col-lg-7 mb-2">
                  <h4 className="color-white">
                    {props.certificationData &&
                      props.certificationData.exam_link}
                  </h4>
                </div>
              </div>

              <div className="row">
                <div className="col-lg-5 mb-2">
                  <h4 className="color-white">Product Link:</h4>
                </div>
                <div className="col-lg-7 mb-2">                  
                    <h4 className="color-white">
                      {props.certificationData &&
                        props.certificationData.product_link}
                    </h4>                 
                </div>
              </div>

              <div className="row">
                <div className="col-lg-12 mb-2">
                  <h4 className="color-white">Description</h4>
                </div>
                <div className="col-lg-12 mb-2">
                  <h4 className="color-white">
                    {props.certificationData &&
                      props.certificationData.certification_description}
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CertificationShowModal;
